import { Load } from 'types/Load';
import { LoadAttributes } from 'types/LoadAttributes';
import { UpdateTMSLoadPayload } from 'types/api/LoadPayload';

export enum TMSOperation {
  UpdateLoad = 'UpdateLoad',
  AssignOperator = 'AssignOperator',
  UpdateOperator = 'UpdateOperator',
  RemoveOperator = 'RemoveOperator',
}

export type UpdateTMSRequest = {
  operation: TMSOperation;
  load: UpdateTMSLoadPayload;
};

export type UpdateTMSResult = {
  load: Load;
  loadAttributes: LoadAttributes;
  message: string;
  errorLevel?: 'error' | 'warning'; // Error level for partial success scenarios (e.g., Revenova post-update warnings)
};
